type Props = {
  children: React.ReactNode
}

export const Warning = ({children}: Props) => {
  return <div className="text-orange-400 text-sm">{children}</div>
}
